import { Injectable } from '@angular/core';

import { LoadingController, Loading } from 'ionic-angular';

import { TranslateService } from '@ngx-translate/core';

import 'rxjs/add/operator/map';

@Injectable()
export class LoadingProvider {

  loading: Loading;

  constructor(private translate: TranslateService, public loadingCtrl: LoadingController) {

  }

  /**
  * Loading visualiser starts immediately.
  * @param text Loading text translation key
  */
  public start(text: string) {
    var x = {};
    if(text != '') {
      x = {
        content: this.translate.instant('LOADING.' + text)
      }
    }
    this.loading = this.loadingCtrl.create(x);
    this.loading.present();
  }

  /**
  * Shows new message in loading visualization.
  * @param text Loading text translation key
  */
  changeContent(text: string) {
    if (this.loading) {
      this.loading.setContent(this.translate.instant('LOADING.' + text));
    }
  }

  /**
  * Pass the Loading text translation as parameter. Current loading text will
  * be altered.
  */
  changeContentWithProgress(text: string, current: number, total: number) {
    if (this.loading) {
      this.loading.setContent(this.translate.instant( 'LOADING.' + text ) + " " + ((current / total) * 100).toFixed(0) + "%");
    }
  }

  /**
  * Stops the current loader.
  */
  stop() {
    if (this.loading) {
      this.loading.dismiss();
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/loading/loading.ts